<template>
    <div class="btn-group">
        <button v-if="canEdit" class="btn btn-secondary btn-sm" @click="edit">
            <i class="fas fa-edit"></i>
        </button>
    </div>
</template>

<script>

  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {boolean}
       */
      canEdit() {
        return this.row.canEdit;
      },

      /**
       * @return {string}
       */
      editUrl() {
        return this.row.editUrl;
      },
    },

    methods: {
      /**
       * @event edit
       */
      edit() {
        this.$emit('edit', {row: this.row, url: this.editUrl});
      },
    },
  }
</script>

